'use client'

import {useState} from 'react'

import {RegistrationForm} from '@/app/components/auth/registration-form'
import {RegistrationStatusSuccess} from '@/app/components/auth/registration-status'

export default function Registration({emailConfirmation = false}: {emailConfirmation?: boolean}) {
  const [registrationComplete, setRegistrationComplete] = useState(false)
  const [userCreated, setUserCreated] = useState(true)

  return (
    <>
      {!emailConfirmation && <RegistrationStatusSuccess isOpen={registrationComplete} userCreated={userCreated} />}
      <RegistrationForm
        setRegistrationStatus={setRegistrationComplete}
        setUserCreated={setUserCreated}
        emailConfirmation={emailConfirmation}
      />
    </>
  )
}
